import { PRODUCTS_SUCCESSFUL_FETCH, SHOW_ERROR_MESSAGE } from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const fetchProducts = (projectId, searchCriteria, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/products",
        {
            params: {
                projectId: projectId,
                searchCriteria: searchCriteria
            }
        })
        .then((response) => {
            dispatch({
                type: PRODUCTS_SUCCESSFUL_FETCH,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}


// WEBPACK FOOTER //
// ./src/reducers/product/productActions.js